import {getStore, setStore} from '@/utils/store'
// import {getUserInfo} from '@/api/login'


const user = {
  state: {
    access_token: getStore({
      name: 'access_token'
    }) || '',
    refresh_token: getStore({
      name: 'refresh_token'
    }) || ''
  },
  actions: {
    // 查询用户信息
    GetUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        // getUserInfo().then((res) => {
        //   const data = res.data.data || {}
        //   commit('SET_USER_INFO', data.sysUser)
        //   commit('SET_ROLES', data.roles || [])
        //   commit('UPDATE_PERMISSIONS', data.permissions || [])
        //   resolve(data)
        // }).catch(() => {
        //   reject()
        // })
      })
    }
  },
  mutations: {
    SET_ACCESS_TOKEN: (state, access_token) => {
      state.access_token = access_token
      setStore({
        name: 'access_token',
        content: state.access_token,
        type: 'session'
      })
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: userInfo,
        type: 'session'
      })
    },
    SET_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i].authority] = true
      }

      state.permissions = list
      setStore({
        name: 'permissions',
        content: list,
        type: 'session'
      })
    },
    UPDATE_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i]] = true
      }

      state.permissions = list
      setStore({
        name: 'permissions',
        content: list,
        type: 'session'
      })
    }
  }
}
export default user
